export default [
	{
		"title": "管理",
		"list": [
			{
				"role": [
					"prefect",
					"manager"
				],
				"title": "请假审批",
				"image": "https://web.yiqiba.xin/appmenupic/1fa674673ef341c1b83eda96e4fc4883.png",
				"type": "local",
				"target": "/pages/leave/leaveTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"prefect",
					"manager"
				],
				"title": "代请假审批",
				"image": "https://web.yiqiba.xin/appmenupic/51559c0d85a442fe967da436f623f74d.png",
				"type": "local",
				"target": "/pages/leave/leaveReplace/leaveReplaceTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"prefect",
					"manager"
				],
				"title": "课程点名统计",
				"image": "https://web.yiqiba.xin/appmenupic/5355880f6ee049aa89b851e4a8090705.png",
				"type": "local",
				"target": "/pages/leave/course/statice",
				"show": true,
				"isVip": false
			},
			{
				"title": "学生评价驾驶舱",
				"target": "/pages/admin/principalDashboard",
				"image": "https://web.yiqiba.xin/appmenupic/73d59ede8435436c9fe6bb24eee7047e.png",
				"role": [
					"headmaster"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "五育评价驾驶舱",
				"target": "/pages/admin/principalEvalDashboard",
				"image": "https://web.yiqiba.xin/appmenupic/cdf575d00da14abc8925a5d8573c1a85.png",
				"role": [
					"headmaster"
				],
				"type": "local",
				"show": true,
				"isVip": false
			}
		]
	},
	{
		"title": "考勤",
		"list": [
			{
				"role": [
					"student"
				],
				"title": "个人考勤",
				"image": "https://web.yiqiba.xin/appmenupic/c0a70c793eb44ac1900849e4f350c6bd.png",
				"type": "local",
				"target": "/pages/atten/atten",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "人员考勤",
				"image": "https://web.yiqiba.xin/appmenupic/d87fd47607524b389a851dfa5a7c6ad7.png",
				"type": "local",
				"target": "/pages/atten/attenTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "宿舍考勤",
				"image": "https://web.yiqiba.xin/appmenupic/6b21c14aabb0406ba77323d3d0e54583.png",
				"type": "local",
				"target": "/pages/dormitory/dormitory",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "班级宿舍考勤",
				"image": "https://web.yiqiba.xin/appmenupic/289e06cd27db48f086017eab5b66f420.png",
				"type": "local",
				"target": "/pages/dormitory/dormitoryTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"condition": "IsHostelAdmin",
				"title": "宿寝考勤",
				"image": "https://web.yiqiba.xin/appmenupic/f7017a90241b4108982edd4f62c027ad.png",
				"type": "local",
				"target": "/pages/dormitory/dormitoryBuilding",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "校车考勤",
				"image": "https://web.yiqiba.xin/appmenupic/5233b44c27f3437fabebd79abae15e86.png",
				"type": "local",
				"target": "/pages/schoolBus/schoolBus",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"condition": "classTeacher",
				"title": "校车考勤",
				"image": "https://web.yiqiba.xin/appmenupic/4b2157f7cf2746d9b6714394ff07132d.png",
				"type": "local",
				"target": "/pages/schoolBus/schoolBusTeacher",
				"query": {
					"type": "1"
				},
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "跟车校车考勤",
				"image": "https://web.yiqiba.xin/appmenupic/50febab9102e413fb3c8156ae1d61414.png",
				"type": "local",
				"target": "/pages/schoolBus/schoolBusTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"manager",
					"teacher"
				],
				"title": "课程点名",
				"image": "https://web.yiqiba.xin/appmenupic/3354eb08ec5f4a029353f61e4b1e5810.png",
				"type": "local",
				"target": "/pages/leave/course/index",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"manager"
				],
				"condition": "classTeacher",
				"title": "课程点名统计",
				"image": "https://web.yiqiba.xin/appmenupic/e26ca812d5e545e8b07bb00326311a2a.png",
				"type": "local",
				"target": "/pages/leave/course/statice",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "调代课",
				"image": "https://web.yiqiba.xin/appmenupic/5c16ffd5bd3f4a2a82a72958ed50f1fe.png",
				"type": "local",
				"target": "/pages/leave/adjustment/index",
				"show": true,
				"isVip": false
			},
			{
				"title": "值班管理",
				"target": "/pages/leave/course/courseMenu",
				"image": "https://web.yiqiba.xin/appmenupic/f3440db21eeb4c7a8b32c6450522909b.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "学生考勤",
				"target": "/pages/attendance/index",
				"image": "https://web.yiqiba.xin/appmenupic/8507a4dc17cd47f6bf0f1f182fadabb3.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "学生考勤",
				"target": "/pages/attendance/parent-records",
				"image": "https://web.yiqiba.xin/appmenupic/d99002a99c814b9d8d37c3a5d661e288.png",
				"role": [
					"student"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "工作考勤",
				"target": "pages/headTeacherAttendance/index",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E5%B7%A5%E4%BD%9C%E8%80%83%E5%8B%A4_260807093319.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false,
				"condition": "classTeacher"
			}
		]
	},
	{
		"title": "请假",
		"list": [
			{
				"role": [
					"student"
				],
				"title": "个人请假",
				"image": "https://web.yiqiba.xin/appmenupic/a3a6e81f559d4ea897a614e7f7989442.png",
				"type": "local",
				"target": "/pages/leave/leave",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "请假管理",
				"image": "https://web.yiqiba.xin/appmenupic/7571a3798a314d99848d2a82225c8543.png",
				"type": "local",
				"target": "/pages/leave/leaveTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "返校申请",
				"image": "https://web.yiqiba.xin/appmenupic/7dd1efb3340c4cf5a26fb3418ca1de47.png",
				"type": "local",
				"target": "/pages/leave/backSchool/backSchool",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "返校管理",
				"image": "https://web.yiqiba.xin/appmenupic/f6fa0b2145ad4442b8c8a2325fca3cf3.png",
				"type": "local",
				"target": "/pages/leave/backSchool/backSchoolTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"condition": [
					"classTeacher",
					"IsHostelAdmin"
				],
				"title": "周期代请假",
				"image": "https://web.yiqiba.xin/appmenupic/da61ab279bf1414abfc8ff9f859e72a9.png",
				"type": "local",
				"target": "/pages/leave/leaveReplace/leaveReplaceList",
				"show": true,
				"isVip": false,
				"remake": "按周,按日,单次的审批代请假"
			},
			{
				"role": [
					"student"
				],
				"title": "代请假确认",
				"image": "https://web.yiqiba.xin/appmenupic/bfe0e8c883584d379d5d67a9e9dc30bf.png",
				"type": "local",
				"target": "/pages/leave/leaveReplace/leaveReplaceParent",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "代请假",
				"image": "https://web.yiqiba.xin/appmenupic/2ae8b51f553d4f8f995c4ec2f226cc06.png",
				"type": "local",
				"target": "/pages/leave/leaveReport/leaveReport",
				"query": {
					"teacher": "1"
				},
				"show": true,
				"isVip": false,
				"remake": "自动通过的代请假，限制24小时"
			},
			{
				"role": [
					"teacher"
				],
				"title": "宿舍代请假",
				"image": "https://web.yiqiba.xin/appmenupic/0792a50207f643f89e2ed0e69afd7658.png",
				"type": "local",
				"target": "/pages/leave/leaveReport/leaveReport",
				"query": {
					"dorm": "1"
				},
				"show": true,
				"isVip": false,
				"remake": "自动通过的代请假，限制24小时"
			},
			{
				"title": "调代课",
				"target": "/pages/leave/adjustment/index",
				"image": "https://web.yiqiba.xin/appmenupic/944777bd1a91456d8976a5635e561015.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "请假统计",
				"target": "/pages/leave/adminLeaveStat",
				"image": "https://web.yiqiba.xin/appmenupic/f735e5adaad34a669174206748041620.png",
				"role": [
					"teacher",
					"manager",
					"prefect",
					"headmaster"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "学生请假审批",
				"image": "https://web.yiqiba.xin/appmenupic/a6efef1139d84e9391924be11e687472.png",
				"type": "local",
				"target": "/pages/leave/leaveTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "返校申请审批",
				"image": "https://web.yiqiba.xin/appmenupic/a669f3b818c74b72b61f594e2a336546.png",
				"type": "local",
				"target": "/pages/leave/backSchool/backSchoolTeacher",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "返校超时列表",
				"image": "https://web.yiqiba.xin/appmenupic/b127ff44a525413989e2bd83de60c1b2.png",
				"type": "local",
				"target": "/pages/leave/backSchool/backTimeOut",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "代请假审批",
				"image": "https://web.yiqiba.xin/appmenupic/bb4aa0cb96d04ca1a8c6bd2a3da6d9cd.png",
				"type": "local",
				"target": "/pages/leave/leaveReplace/leaveReplaceTeacher",
				"show": true,
				"isVip": false
			}
		]
	},
	{
		"title": "消费",
		"list": [
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "我的余额",
				"image": "https://web.yiqiba.xin/appmenupic/3a19d17cf6314e1aac92965d9c7f2a33.png",
				"type": "local",
				"target": "/pages/consumption/consumption",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "消费记录",
				"image": "https://web.yiqiba.xin/appmenupic/d00b03a67af34efa94bdb1877f732156.png",
				"type": "local",
				"target": "/pages/consumption/consumptionDetail/consumptionDetail",
				"query": {
					"type": "2"
				},
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "订餐",
				"image": "https://web.yiqiba.xin/appmenupic/2bb6a68378e248bdbeb804d0e60d4463.png",
				"type": "local",
				"target": "/pages/consumption/order/order",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "订餐",
				"image": "https://web.yiqiba.xin/appmenupic/5ea166cd289f46a3ac6971d4bd331a24.png",
				"type": "local",
				"target": "/pages/consumption/order/teacherOrder",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"condition": "IsSubsidyAuth",
				"title": "学生补贴",
				"image": "https://web.yiqiba.xin/appmenupic/8bd69379af124cd58156be217abf4cf1.png",
				"type": "local",
				"target": "/pages/consumption/subsidies/subsidies",
				"show": true,
				"isVip": false
			}
		]
	},
	{
		"title": "德育",
		"list": [
			{
				"role": [
					"student"
				],
				"title": "成长详情",
				"image": "https://web.yiqiba.xin/appmenupic/c0f3f308be834d47967371e15d4bdd40.png",
				"type": "local",
				"target": "/pages/moralEducation/user",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "班级检查",
				"image": "https://web.yiqiba.xin/appmenupic/55b76d38971046348e276fa0f9a79195.png",
				"type": "local",
				"target": "/pages/moralEducation/classInspection",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "学生评价",
				"image": "https://web.yiqiba.xin/appmenupic/fe926c160a8045d982c1664028bd9599.png",
				"type": "local",
				"target": "/pages/moralEducation/studentEvaluation",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "评价统计",
				"image": "https://web.yiqiba.xin/appmenupic/9005a1e39c5248f89894ae429aba5459.png",
				"type": "local",
				"target": "/pages/moralEducation/teacherStatice",
				"show": true,
				"isVip": false
			},
			{
				"title": "批量评价",
				"target": "/pages/moralEducation/batchEvaluation",
				"image": "https://web.yiqiba.xin/appmenupic/c0ff267b24164c45add0384c0040c15f.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "德育商城",
				"target": "/pages/integral/integralMenu",
				"image": "https://web.yiqiba.xin/appmenupic/540d850aa75c44a0b7203526a5698503.png",
				"role": [
					"student",
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "哲商德育",
				"target": "/pages/integraZS/integraZSMenu",
				"image": "https://web.yiqiba.xin/appmenupic/dbe45001d22c4dba936085ae5c4dbeed.png",
				"role": [
					"student",
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "班级积分抽奖",
				"target": "/pages/classLottery/menu",
				"image": "https://web.yiqiba.xin/appmenupic/6092184a1dea45659fcfb2442b7447aa.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false,
				"condition": "classTeacher"
			},
			{
				"title": "我的积分",
				"target": "/pages/integral/myPoints",
				"image": "https://web.yiqiba.xin/appmenupic/a6ff727912d0419cbd4a0ecfbb5bc439.png",
				"role": [
					"student"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "五育评价",
				"target": "/pages/fiveEducation/index",
				"image": "https://web.yiqiba.xin/appmenupic/36b138d5446e4f93abe67d1350daf1cd.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "评价报告",
				"target": "/pages/moralEducation/report",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E8%AF%84%E4%BB%B7%E6%8A%A5%E5%91%8A_260716180714.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false,
				"condition": "classTeacher"
			},
			{
				"title": "协约币",
				"target": "/pages/agreementCoin/index",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E5%B8%81_260728122825.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false,
				"condition": "classTeacher"
			},
			{
				"title": "协约币",
				"target": "/pages/agreementCoin/parentCoin",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E5%B8%81_260728122900.png",
				"role": [
					"student"
				],
				"type": "local",
				"show": true,
				"isVip": false
			}
		]
	},
	{
		"title": "互动",
		"list": [
			{
				"role": [
					"student"
				],
				"title": "聊天",
				"image": "https://web.yiqiba.xin/appmenupic/afd065fd102342e8bfcfd3ea5be35a40.png",
				"type": "local",
				"target": "/pages/cplate/chat",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "课程",
				"image": "https://web.yiqiba.xin/appmenupic/a87b9786a88848579a306998d7b8fdaf.png",
				"type": "local",
				"target": "/pages/cplate/courses",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "荣誉",
				"image": "https://web.yiqiba.xin/appmenupic/389059db8b1a473891cfaa1f2d79117e.png",
				"type": "local",
				"target": "/pages/cplate/universalMedia",
				"query": {
					"type": "1"
				},
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "风采",
				"image": "https://web.yiqiba.xin/appmenupic/03802e077e75479cbba6e16de221d699.png",
				"type": "local",
				"target": "/pages/cplate/universalMedia",
				"query": {
					"type": "2"
				},
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student",
					"teacher"
				],
				"title": "视频",
				"image": "https://web.yiqiba.xin/appmenupic/73543a7dd52640caa0e4e4b0b5d5be70.png",
				"type": "local",
				"target": "/pages/cplate/universalMedia",
				"query": {
					"type": "3"
				},
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "德育分",
				"image": "https://web.yiqiba.xin/appmenupic/867fd67431fe467c9b6af4d746d5943f.png",
				"type": "local",
				"target": "/pages/cplate/moralEducation",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"condition": "IsTempNews",
				"title": "新闻审核",
				"image": "https://web.yiqiba.xin/appmenupic/44cf016bff804c429d082b3135776cfe.png",
				"type": "local",
				"target": "/pages/cplate/news",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "放学管理",
				"image": "https://web.yiqiba.xin/appmenupic/34cc23e3c3214dbcbdc210a809aacd7d.png",
				"type": "local",
				"target": "/pages/cplate/outSchool",
				"show": true,
				"isVip": false
			},
			{
				"title": "班级信息管理",
				"target": "/pages/cplate/cplateMenu",
				"image": "https://web.yiqiba.xin/appmenupic/ee833c464545481f9378df0157e41eb0.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false,
				"condition": "classTeacher"
			},
			{
				"title": "荣誉管理",
				"target": "/pages/cplate/honorCollection",
				"image": "https://web.yiqiba.xin/appmenupic/ebb2e79e803e4b0280d6970a9f3aa3a7.png",
				"role": [
					"student",
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "校级活动",
				"target": "/pages/cplate/activityAdmin",
				"image": "https://web.yiqiba.xin/appmenupic/90e575abb53a44feaf182cd17eb20968.png",
				"role": [
					"headmaster"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "大屏管理",
				"target": "/pages/bigScreen/index",
				"image": "https://web.yiqiba.xin/appmenupic/37ed67daaafc452a838910900663950b.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "五星班级发布",
				"target": "/pages/cplate/fiveStarClass",
				"image": "https://web.yiqiba.xin/appmenupic/ec83f3a26b9b47f4b2c1cb8b53eb5f4f.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "班级圈",
				"target": "/pages/classCircle/index",
				"image": "https://web.yiqiba.xin/appmenupic/71df5772641a4410ae4fd904c9b280ba.png",
				"role": [
					"student",
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "表彰称号",
				"target": "/pages/cplate/honorTitle",
				"image": "https://web.yiqiba.xin/appmenupic/f18b80c70b12410a90ea40f9a8d067ff.png",
				"role": [
					"student",
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "校园公话",
				"target": "/pages/phone/axdPhone",
				"image": "https://web.yiqiba.xin/appmenupic/3e24ff3236764d5c8f588c01508bc1b1.png",
				"role": [
					"student"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "通话订阅",
				"image": "https://web.yiqiba.xin/static/subscribe.png",
				"type": "weapp",
				"show": true,
				"appId": "wx18b0a18dc423ad0b",
				"target": "pages/index/subscription",
				"extraData": [
					{
						"key": "parentId",
						"source": "user.StudentParentId"
					},
					{
						"key": "departmentId",
						"source": "user.DeptId"
					}
				],
				"isVip": false
			}
		]
	},
	{
		"title": "更多功能",
		"list": [
			{
				"role": [
					"teacher"
				],
				"title": "人员管理",
				"image": "https://web.yiqiba.xin/appmenupic/ec508a1b52a04e13b70de8453bf02e00.png",
				"type": "local",
				"target": "/pages/users/users",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "社团管理",
				"image": "https://web.yiqiba.xin/appmenupic/408df08ac5954e02a92e3baae447f323.png",
				"type": "local",
				"target": "/pages/leave/associations/index",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "作业公示",
				"image": "https://web.yiqiba.xin/appmenupic/554f997ff4104a0db32d638d84efa281.png",
				"type": "local",
				"target": "/pages/cplate/reportJob",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"student"
				],
				"title": "测温日报",
				"image": "https://web.yiqiba.xin/appmenupic/4782eb47f0844369ab1700acb1f99a36.png",
				"type": "local",
				"target": "/pages/temperature/temperatureDetail/temperatureDetail",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "测温统计",
				"image": "https://web.yiqiba.xin/appmenupic/8f65c77c47e94578b9a3703902de9acb.png",
				"type": "local",
				"target": "/pages/temperature/temperatureReport/temperatureReport",
				"show": true,
				"isVip": false
			},
			{
				"role": [
					"teacher"
				],
				"title": "测温仪",
				"image": "https://web.yiqiba.xin/appmenupic/dbfb1d3d8912401886fdfefbac64ea45.png",
				"type": "local",
				"target": "/pages/temperature/temperature",
				"show": true,
				"isVip": false
			},
			{
				"title": "工作记录",
				"target": "/pages/workRecord/index",
				"image": "https://web.yiqiba.xin/appmenupic/03bd056753ce4ca6935c4991f68223af.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "教研组",
				"target": "/pages/teachingResearch/index",
				"image": "https://web.yiqiba.xin/appmenupic/6f642bb32a2d40b381da4b7d9790b54a.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "家长车牌登记",
				"target": "/pages/cplate/parentVehicle",
				"image": "https://web.yiqiba.xin/appmenupic/e436b12fe31a4f90a81fe26fccb0fde9.png",
				"role": [
					"student"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "违停管理",
				"target": "/pages/cplate/violationList",
				"image": "https://web.yiqiba.xin/appmenupic/24903e4d266c408c86a31bab96114e08.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "教师巡检统计",
				"target": "/pages/cplate/patrolRegister",
				"image": "https://web.yiqiba.xin/appmenupic/7891b9bfe5ee4c76a2d0a7b0bb2f4d2b.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "家访管理",
				"target": "/pages/homeVisit/index",
				"image": "https://web.yiqiba.xin/appmenupic/8489815333134577bd648aa2815c8679.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "设备报修",
				"target": "/pages/repair/index",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E4%BF%9D%E4%BF%AE%E7%AE%A1%E7%90%86_260707140008.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			},
			{
				"title": "智慧会议",
				"target": "/pages/meetingroom/index",
				"image": "https://global-resource-image.oss-cn-shanghai.aliyuncs.com/yiqixiaoyuan/images/appmenupic/%E6%99%BA%E8%83%BD%E4%BC%9A%E8%AE%AE%E5%AE%A4_260718234609.png",
				"role": [
					"teacher"
				],
				"type": "local",
				"show": true,
				"isVip": false
			}
		]
	}
]
